import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { phoneNumberValidator } from 'src/app/shared/validators/phone-number.validator';

export function toTitleCase(text: string): string {
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}

function removeUnderscore(str) {
  return str.replace(/_/g, ' ');  // Remove all underscores
}

function formatUnderscoredValue(str) {
  return str
    .replace(/_/g, ' ')          // Replace underscores with spaces
    .split(' ')                  // Split into words by space
    .map(word =>                 // Capitalize each word
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ');                  // Join the words back with spaces
}


export function sortObjectsByKey<T>(list: T[], key: keyof T): T[] {
  return list.sort((a, b) => a[key].toString().localeCompare(b[key].toString()));
}

@Component({
  selector: 'app-taxpayer-modal',
  standalone: false,
  templateUrl: './taxpayer-modal.component.html',
  styleUrl: './taxpayer-modal.component.scss'
})
export class TaxpayerModalComponent {
  categoryItemForm: FormGroup;
  detailsForm: FormGroup;
  isDarkMode!: boolean;

  details: any;


  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  itemList: any[];
  isListUpdated = false;


  vehicleTypes: any[] = [];

  rememberMe: boolean;



  isInEditingMode: boolean = false;

  assessmentTypes: any[];
  profilingTypes: any[];
  categories: any[];

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TaxpayerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();

    this.getAllVehicleTypes();

    this.categoryItemForm.get('vehicleTypeId')?.valueChanges.subscribe((id) => {
      const vehicle = this.vehicleTypes.find((v) => v.id === id);
      this.categoryItemForm.patchValue({ vehicleTypeName: vehicle ? vehicle.name : '' });
    });

    this.rememberMe = false;



    this.isInEditingMode = Boolean(this.dialogData?.isInEditingMode);

    if (!this.isInEditingMode) {
      this.categoryItemForm.disable()
    }



    if (this.dialogData?.id) {
      this.fetchDetails()
    }

    this.subscribeToprofilingTypeControl()
    this.fetchProfilingTypes()


  }

  initForm(): void {
    this.categoryItemForm = this.fb.group({
      // assessmentType: [null, [Validators.required]],

      profilingType: [null, [Validators.required]],
      category: [null, [Validators.required]],
    });


    this.detailsForm = this.fb.group({
      asin: [null, [Validators.required]],
      phoneNumber: [null, [Validators.required]],
      address: [null, [Validators.required]],
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      lga: [null, [Validators.required]],
    });

  }



  // get assessmentTypeControl(): FormControl {
  //   return this.categoryItemForm.get('assessmentType')! as FormControl
  // }

  get profilingTypeControl(): FormControl {
    return this.categoryItemForm.get('profilingType')! as FormControl
  }
  get categoryControl(): FormControl {
    return this.categoryItemForm.get('category')! as FormControl
  }



  fetchProfilingTypes() {

    this.apiService
      .get(`/utility/profiling-type`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {

        this.profilingTypes = response.map(item => ({ ...item, disabled: false }));

      });
  }





  fetchCategories(profilingTypeId: number) {
    this.categories = null;
    this.categoryControl.reset()
    this.apiService
      .get(`/utility/profiling-category?profilingTypeId=${profilingTypeId}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {

        this.categories = response;
      });
  }

  subscribeToprofilingTypeControl() {
    this.profilingTypeControl.valueChanges.subscribe((category: any) => {
      if (category) {
        this.fetchCategories(category);
      }
    })
  }

  // subscribeToAssessmentTypeControl() {
  //   this.assessmentTypeControl.valueChanges.subscribe((assessmentType: any) => {
  //     if (assessmentType) {
  //       this.fetchProfilingTypes(assessmentType);
  //     }
  //   })
  // }



  allowEditing() {
    this.isInEditingMode = true;
    this.categoryItemForm.enable()
  }

  fetchDetails() {
    this.details = this.dialogData
    this.mapFormValues(this.dialogData)

    this.apiService
      .get(`/taxpayer/details/${this.dialogData?.asin}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.details = response;
        const mappedProfileDetails = response?.taxpayerProfile?.map((item: any) => ({
          category: {
            id: item.profilingCategoryId,
            amount: item.regAmount,
            revenueDescription: item.profilingCategory,
          },
          profilingType: {
            category: item.profilingType,
            id: item.profilingTypeId
          }
        }))

        this.itemList = mappedProfileDetails ? mappedProfileDetails : [];


        this.mapFormValues(response)
      });
  }

  mapFormValues(data: any) {
    const [firstName = '', lastName = ''] = data?.displayName?.trim().split(/\s+/) ?? [];

    this.detailsForm.patchValue({
      phoneNumber: data?.phoneNumber,
      address: data?.address,
      asin: data?.asin,
      firstName,
      lastName
    })




  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data?.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }


  closeModal(): void {
    if (this.detailsForm.dirty || this.isListUpdated) {
      let dialogRef = this.dialog.open(ConfirmActionComponent, {
        width: '400px',
        backdropClass: 'modal-form-backdrop',
        hasBackdrop: true,
        panelClass: ['modal-form', 'modal-no-overflow-changed'],
        disableClose: true,

        data: {
          title: 'Are you sure you want to exit? You will lose all unsaved changes.',
          body: '',
          confirmText: 'Yes',
          lottieIconPath: 'assets/lottie/alert.json',
          onConfirm: () => {
            this.dialogRef.close();
          },
          onCancel: () => {
            return;
          },
          showCancelButton: true,
          showConfirmButton: true,
        },
      });
    }
    else {
      if (!this.isSubmitting) {
        this.dialogRef.close();
      }
    }




  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  confirmUpdateTaxpayerProfile() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to update this taxpayer proflile?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.updateUser();
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }


  confirmCreateUser() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to create a profile for this user?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.createTaxpayerProfile()

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  markListAsUpdated() {
    this.isListUpdated = true;
  }

  addItemToList(): void {
    const formValues = this.categoryItemForm.value;



    if (this.categoryItemForm.valid) {


      const categoryAlreadyAdded = this.itemList.find((item) => item?.profilingType?.id == formValues?.profilingType && item?.category?.id == formValues?.category)

      if (Boolean(categoryAlreadyAdded)) {
        this.categoryControl.setErrors({ duplicateEntry: categoryAlreadyAdded.category.revenueDescription });
        this.showErrorMessages = false;
        return;
      }



      const profilingType = this.profilingTypes.find((item: any) => item.id == formValues?.profilingType);
      const category = this.categories.find((item: any) => item.id == formValues?.category);




      this.itemList.push({ profilingType, category });



      this.markListAsUpdated()
      this.categoryItemForm.reset();
      this.showErrorMessages = false;


      if (profilingType.id != 1) { //Disable added profiling type(Except for licenses, for which duplicate entries are allowed)
        profilingType.disabled = true;
        this.profilingTypes = [...this.profilingTypes];
      }
    } else {
      this.showErrorMessages = true
    }
  }

  removeItem(index: number, item: any): void {
    this.itemList.splice(index, 1);

    const profilingType = this.profilingTypes.find((pt) => pt.id === item.profilingType.id);
    if (profilingType) {
      profilingType.disabled = false;
      this.profilingTypes = [...this.profilingTypes];
    }

    this.markListAsUpdated()
  }

  createTaxpayerProfile(): void {
    this.isSubmitting = true;
    this.categoryItemForm.disable();

    const formValues = this.categoryItemForm?.value;

    const request = {
      asin: this.details?.asin,
      requests: this.itemList.map((item) => ({ amount: item.category.amount, profilingType: item.profilingType.id, profilingCategory: item.category.id }))
      // parkId
    };

    this.apiService
      .post(`/taxpayer/create`, request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.categoryItemForm.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

          this.dialogRef.close();
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }

  updateUser(): void {
    this.isSubmitting = true;
    this.categoryItemForm.disable();

    const formValues = this.categoryItemForm?.value;

    const request = {
      asin: this.details?.asin,
      requests: this.itemList.map((item) => ({ amount: item.category.amount, profilingType: item.profilingType.id, profilingCategory: item.category.id }))
      // parkId
    };
    
    this.apiService
      .post(`/taxpayer/update`, request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.categoryItemForm.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

          this.dialogRef.close();
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }
}
